import React from 'react';

const SIZE = 1700;

const LandingRings = ({ className, rings, core, nodes = [] }) => (
  <svg
    className={`lp-ring-set ${className}`}
    width={SIZE}
    height={SIZE}
    viewBox={`${-SIZE / 2} ${-SIZE / 2} ${SIZE} ${SIZE}`}
    aria-hidden="true"
    focusable="false"
  >
    {rings.map((ring) => (
      <ellipse
        key={`${ring.rx}-${ring.ry || ring.rx}`}
        rx={ring.rx}
        ry={ring.ry || ring.rx}
        fill="none"
        stroke={ring.color}
        strokeOpacity={ring.opacity}
        strokeWidth={ring.width || 1}
        strokeDasharray={ring.dashed ? '4 6' : undefined}
        vectorEffect="non-scaling-stroke"
      />
    ))}
    {core ? <circle r={core.r} fill={core.color} fillOpacity={core.opacity || 1} /> : null}
    {nodes.map(([cx, cy]) => (
      <g key={`${cx}-${cy}`}>
        <circle cx={cx} cy={cy} r={15.5} fill="none" stroke="#00afd7" strokeOpacity={0.45} />
        <circle cx={cx} cy={cy} r={6} fill="#00afd7" />
      </g>
    ))}
  </svg>
);

export const HERO_NODES = [[-76, -506], [-151, -329], [-163, -165]];

export const HERO_RINGS = [
  { rx: 73, ry: 70, color: '#9fd9ea', opacity: 0.34, width: 1.5 },
  { rx: 120, color: '#3dc4e3', opacity: 0.31, width: 1.5 },
  { rx: 178, color: '#9fd9ea', opacity: 0.28, width: 1.5 },
  { rx: 241, ry: 232, color: '#9fd9ea', opacity: 0.26, dashed: true },
  { rx: 300, color: '#9fd9ea', opacity: 0.23 },
  { rx: 362, color: '#3dc4e3', opacity: 0.2 },
  { rx: 455, ry: 438, color: '#9fd9ea', opacity: 0.17 },
  { rx: 512, color: '#9fd9ea', opacity: 0.14, dashed: true },
  { rx: 600, color: '#9fd9ea', opacity: 0.12 },
  { rx: 717, ry: 690, color: '#3dc4e3', opacity: 0.09 },
  { rx: 790, color: '#9fd9ea', opacity: 0.06 }
];

export const SERVE_RINGS = [
  { rx: 80, color: '#00afd7', opacity: 0.14 },
  { rx: 135, color: '#00afd7', opacity: 0.13, dashed: true },
  { rx: 190, color: '#00afd7', opacity: 0.11 },
  { rx: 245, color: '#00afd7', opacity: 0.1, dashed: true },
  { rx: 300, color: '#00afd7', opacity: 0.08 },
  { rx: 355, color: '#00afd7', opacity: 0.07, dashed: true }
];

export const CTA_RINGS = [60, 120, 180, 240, 300, 360, 420, 480, 540, 600].map((rx, index) => ({
  rx,
  color: '#00afd7',
  opacity: 0.22 - index * 0.02,
  dashed: index === 2 || index === 5 || index === 8
}));

export default LandingRings;
